import _ from 'lodash';

import Constants from '../../Constants';
import VirtualDomElement from '../VirtualDomElement';
import ImageElement from './ImageElement';
import MultilineTextElement from './MultilineTextElement';

export default class LabeledImage extends VirtualDomElement {
  imageElement: ImageElement;
  textElement: MultilineTextElement;
  imageRegistry: any;

  constructor({
    x,
    y,
    label,
    fontSize,
    url,
    borderColor = 'white',
    maxCharacterWidth = 7,
    ellipsis = true,
    maxLines = 1,
    imageRegistry,
    drawPanel = true,
    drawBorder = true,
    onRequestDraw = () => null,
  }) {
    super(onRequestDraw);
    //url="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/Color_icon_blue.svg/800px-Color_icon_blue.svg.png";
    if (url) {
      this.imageElement = new ImageElement({
        x: x,
        y: y,
        url: url,
        maxWidth: 100,
        imageRegistry: imageRegistry,
        onRequestDraw: onRequestDraw,
      });
    }
    this.textElement = new MultilineTextElement({
      text: label,
      fontSize: fontSize,
      maxCharacterWidth: maxCharacterWidth,
      x: x,
      y: y,
      maxLines: maxLines,
      ellipsis: ellipsis,
    });
    this.set('x', x);
    this.set('y', y);
    this.set('borderColor', borderColor);
    this.set('maxCharacterWidth', maxCharacterWidth);
    this.set('fontSize', fontSize);
    this.set('drawPanel', drawPanel);
    this.set('drawBorder', drawBorder);
    this.set('maxLines', maxLines);
    this.set('width', null);
    this.set('height', null);

    this.imageRegistry = imageRegistry;
  }

  getImageElement() {
    return this.imageElement;
  }

  getTextElement() {
    return this.textElement;
  }

  onLoad() {
    this.requestDraw();
  }

  onError() {
    //url could not be loaded
    this.imageElement.onError();
  }

  _drawImage(ctx, transform) {
    ctx.shadowBlur = 4 * transform.k;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.shadowColor = 'rgba(121,125,119,0.99)';
    this.imageElement.draw(ctx, transform);
  }

  _drawLabel(ctx, transform) {
    const textHeight = this.textElement.get('height');
    const textWidth = this.textElement.get('width');

    const heightPanel = textHeight * 1.45;
    const colorStripHeight = this.get('fontSize') * 0.3;

    if (!this.get('width')) {
      //center everything
      this.set('width', textWidth);
      this.set('x', this.get('x') - textWidth / 2);
      if (this.imageElement) {
        this.imageElement.set('width', textWidth);
        this.imageElement.set('x', this.get('x'));
      }
    }
    if (!this.get('height')) {
      //center everything
      const offset = this.get('fontSize') + textHeight * 0.2;
      this.set('y', this.get('y') - offset);
      this.set('height', heightPanel);
      if (this.imageElement) {
        //place image under panel
        this.imageElement.set(
          'y',
          this.get('y') + heightPanel + colorStripHeight,
        );
      }
    }

    const [x, y] = transform.apply([this.get('x'), this.get('y')]);

    if (this.get('drawPanel')) {
      ctx.fillRect(x, y, textWidth * transform.k, heightPanel * transform.k);
    }

    if (this.get('drawBorder')) {
      ctx.fillStyle = this.get('borderColor');
      ctx.fillRect(
        x,
        y + heightPanel * transform.k,
        textWidth * transform.k,
        colorStripHeight * transform.k,
      );
    }

    ctx.shadowBlur = 0;
    ctx.fillStyle = '#606060';

    this.textElement.draw(ctx, transform);
  }

  draw(ctx, transform, scaling, options: object = {}) {
    const opacity = _.get(options, 'opacity', 1);
    const scaleFactor = 1;

    ctx.textAlign = 'center';

    ctx.fillStyle = '#ffffff';
    ctx.shadowBlur = Constants.subTopics.shadowBlur * scaleFactor * transform.k;
    ctx.shadowColor = `rgba(121,125,119,${scaleFactor * opacity}`;

    this._drawLabel(ctx, transform);
    if (this.imageElement) {
      this._drawImage(ctx, transform);
    }
    //this.drawBoundingBox(ctx,transform,scaling);

    ctx.shadowBlur = 0;
  }
}
